export const legalLinks = [
  {
    key: "terms",
    path: "/terms",
    label: {
      en: "Terms of Use",
      ru: "Условия использования",
      he: "תקנון שימוש",
    },
  },
  {
    key: "warranty",
    path: "/warranty",
    label: {
      en: "Warranty Terms",
      ru: "Условия гарантии",
      he: "תנאי אחריות",
    },
  },
  {
    key: "privacy",
    path: "/privacy",
    label: {
      en: "Privacy Policy",
      ru: "Политика конфиденциальности",
      he: "מדיניות פרטיות",
    },
  },
  {
    key: "faq",
    path: "/faq",
    label: {
      en: "FAQ",
      ru: "Вопросы и ответы",
      he: "שאלות ותשובות",
    },
  },
];

export const legalPages = {
  terms: {
    title: {
      en: "Terms of Use",
      ru: "Условия использования",
      he: "תקנון שימוש באתר",
    },
    subtitle: {
      en: "Website use and service terms for iFollowers.",
      ru: "Правила использования сайта и сервиса iFollowers.",
      he: "כללי השימוש באתר iFollowers ובשירותים המוצעים בו.",
    },
    updatedAt: {
      en: "Last updated: April 17, 2025",
      ru: "Последнее обновление: 17 апреля 2025",
      he: "עודכן לאחרונה: 17 באפריל 2025",
    },
    intro: {
      en: [
        "Browsing the iFollowers website and using its services constitutes full agreement by the user to all terms listed in this document.",
        "If you do not agree to any of these terms, you should avoid using the website and its services.",
      ],
      ru: [
        "Посещение сайта iFollowers и использование его сервисов означает полное согласие пользователя со всеми условиями, указанными в этом документе.",
        "Если вы не согласны с каким-либо из этих условий, следует воздержаться от использования сайта и его сервисов.",
      ],
      he: [
        "הגלישה באתר iFollowers והשימוש בו מהווים הסכמה מלאה מצד המשתמש לתנאים המפורטים במסמך זה.",
        "אם אינך מסכים לאחד מתנאים אלו – הימנע משימוש בשירות.",
      ],
    },
    sections: [
      {
        number: "1",
        title: {
          en: "Purpose of the Website",
          ru: "Цель сайта",
          he: "מטרת האתר",
        },
        paragraphs: {
          en: [
            "The website provides marketing services for social networks, including the sale of followers, likes, comments and related digital services.",
            "The service is not an official service of any third-party platform and is not affiliated with Instagram, Meta, TikTok or any other platform.",
          ],
          ru: [
            "Сайт предоставляет маркетинговые услуги для социальных сетей, включая продажу подписчиков, лайков, комментариев и сопутствующих цифровых услуг.",
            "Сервис не является официальным продуктом какой-либо сторонней платформы и не связан с Instagram, Meta, TikTok или любой другой платформой.",
          ],
          he: [
            "האתר מספק שירותים שיווקיים לרשתות חברתיות, לרבות מכירת עוקבים, לייקים, תגובות ושירותים דיגיטליים נלווים.",
            "האתר אינו מציע שירותים רשמיים של פלטפורמות צד שלישי ואינו מקושר אליהן בכל דרך. המשתמש מודע לכך שהשירות אינו נתמך או מאושר על ידי Instagram, Meta, TikTok או כל גורם אחר.",
          ],
        },
      },
      {
        number: "2",
        title: {
          en: "Terms of Use",
          ru: "Условия использования",
          he: "תנאי השימוש",
        },
        bullets: {
          en: [
            "The account must be public and not private.",
            "A valid profile picture must be present.",
            "The username and profile URL must not be changed while the service is active.",
            "Followers from other sources must not be purchased in parallel.",
            "Software or browser extensions that may conflict with the service must not be installed or used.",
            "Failure to meet any of these terms immediately voids any warranty or responsibility, without refund.",
          ],
          ru: [
            "Аккаунт должен быть открытым, а не приватным.",
            "На профиле должна быть действующая фотография.",
            "Во время оказания услуги нельзя менять имя пользователя и URL профиля.",
            "Нельзя одновременно заказывать подписчиков из других источников.",
            "Нельзя устанавливать или использовать программы и расширения, которые могут конфликтовать с услугой.",
            "Нарушение любого из этих условий немедленно прекращает любую гарантию или ответственность без возврата средств.",
          ],
          he: [
            "על החשבון להיות ציבורי (לא פרטי).",
            "יש לכלול תמונת פרופיל תקפה.",
            "אין לשנות את שם המשתמש או כתובת ה-URL במהלך השירות.",
            "אין לרכוש עוקבים ממקורות אחרים במקביל.",
            "אין להתקין תוכנות או תוספים העלולים להתנגש עם השירות.",
            "אי עמידה באחד מהתנאים תגרור ביטול אחריות מיידי וללא החזר כספי.",
          ],
        },
      },
      {
        number: "3",
        title: {
          en: "Limited Liability",
          ru: "Ограничение ответственности",
          he: "אחריות מוגבלת",
        },
        paragraphs: {
          en: [
            "The service is provided on an “AS IS” basis, without any warranty of any kind.",
            "The website does not guarantee a specific number of followers, their activity period, service stability or any specific marketing outcome.",
          ],
          ru: [
            "Сервис предоставляется по принципу “AS IS”, без каких-либо гарантий.",
            "Сайт не гарантирует конкретное количество подписчиков, срок их активности, стабильность сервиса или какой-либо конкретный маркетинговый результат.",
          ],
          he: [
            "השירות ניתן “כמות שהוא” (AS IS) וללא אחריות מכל סוג.",
            "האתר אינו מתחייב למספר עוקבים מסוים, לזמן פעילותם, ליציבות השירות או להצלחה שיווקית כלשהי.",
          ],
        },
        bullets: {
          en: [
            "Account suspension",
            "Content blocking",
            "Loss of exposure",
            "Loss of data",
            "Personal or professional frustration",
          ],
          ru: [
            "Блокировку аккаунта",
            "Ограничение или скрытие контента",
            "Снижение охвата",
            "Потерю данных",
            "Личный или профессиональный ущерб и разочарование",
          ],
          he: [
            "השבתת חשבון",
            "חסימת תכנים",
            "ירידה בחשיפה",
            "איבוד נתונים",
            "תסכול אישי או מקצועי",
          ],
        },
      },
      {
        number: "4",
        title: {
          en: "Prohibited Use",
          ru: "Запрещенное использование",
          he: "שימוש אסור",
        },
        bullets: {
          en: [
            "Committing any criminal or civil offense",
            "Publishing false, offensive or harmful content",
            "Manipulating third-party platform mechanisms",
            "Impersonation or fraud",
          ],
          ru: [
            "Совершение уголовных или гражданских правонарушений",
            "Публикация ложного, оскорбительного или вредоносного контента",
            "Манипулирование механизмами сторонних платформ",
            "Выдача себя за другое лицо или мошенничество",
          ],
          he: [
            "ביצוע עבירה פלילית או אזרחית",
            "פרסום תכנים שקריים או פוגעניים",
            "השפעה על מנגנוני פלטפורמות צד ג׳",
            "התחזות או הונאה",
          ],
        },
      },
      {
        number: "5",
        title: {
          en: "Indemnification",
          ru: "Возмещение ущерба",
          he: "שיפוי",
        },
        paragraphs: {
          en: [
            "The user agrees to indemnify and compensate the website owners, employees, suppliers and any third party acting on their behalf for any claim, loss or damage caused by a breach of these terms.",
          ],
          ru: [
            "Пользователь обязуется возместить владельцам сайта, сотрудникам, поставщикам и любым третьим лицам, действующим от их имени, любой ущерб, убытки или претензии, возникшие из-за нарушения этих условий.",
          ],
          he: [
            "המשתמש מתחייב לשפות ולפצות את בעלי האתר, עובדיו, ספקיו וכל צד שלישי מטעמו – בגין כל תביעה, הפסד או נזק שייגרם עקב הפרת התנאים.",
          ],
        },
      },
      {
        number: "6",
        title: {
          en: "Privacy and Information Security",
          ru: "Конфиденциальность и защита информации",
          he: "פרטיות ואבטחת מידע",
        },
        paragraphs: {
          en: [
            "Reasonable efforts are made to maintain privacy, but full protection of information cannot be guaranteed.",
            "The user uses the service at their sole responsibility and waives claims regarding absolute information security.",
          ],
          ru: [
            "Предпринимаются разумные меры для защиты конфиденциальности, однако полная защита информации не гарантируется.",
            "Пользователь использует сервис под свою исключительную ответственность и заранее отказывается от претензий, связанных с абсолютной безопасностью данных.",
          ],
          he: [
            "נעשים מאמצים לשמירה על פרטיות, אך אין התחייבות להגנה מלאה על המידע.",
            "המשתמש משתמש בשירות באחריותו הבלעדית ומוותר מראש על טענות בנושא אבטחת מידע.",
          ],
        },
      },
      {
        number: "7",
        title: {
          en: "Intellectual Property",
          ru: "Интеллектуальная собственность",
          he: "קניין רוחני",
        },
        paragraphs: {
          en: [
            "All content on the website belongs exclusively to the operator. It may not be copied, published or used without explicit written permission.",
          ],
          ru: [
            "Весь контент сайта принадлежит исключительно его оператору. Его нельзя копировать, публиковать или использовать без прямого письменного разрешения.",
          ],
          he: [
            "כל התוכן באתר שייך בלעדית למפעיל. אין להעתיק, לפרסם או להשתמש בו ללא רשות מפורשת בכתב.",
          ],
        },
      },
      {
        number: "8",
        title: {
          en: "Changes to the Terms",
          ru: "Изменения условий",
          he: "שינויים בתקנון",
        },
        paragraphs: {
          en: [
            "The operator may update these terms at any time. Continued use of the website constitutes renewed agreement to the updated version.",
          ],
          ru: [
            "Оператор вправе обновлять эти условия в любое время. Продолжение использования сайта означает повторное согласие с обновленной версией.",
          ],
          he: [
            "המפעיל רשאי לעדכן את התקנון בכל עת. המשך שימוש באתר מהווה הסכמה מחודשת לגרסה המעודכנת.",
          ],
        },
      },
      {
        number: "9",
        title: {
          en: "Jurisdiction",
          ru: "Юрисдикция",
          he: "תחום שיפוט",
        },
        paragraphs: {
          en: [
            "Any dispute will be discussed solely under local law and in the court chosen by the operator. The user waives claims on this matter in advance.",
          ],
          ru: [
            "Любой спор рассматривается исключительно по местному праву и в суде, выбранном оператором. Пользователь заранее отказывается от претензий по этому вопросу.",
          ],
          he: [
            "כל מחלוקת תידון לפי החוק המקומי ובבית משפט לפי בחירת המפעיל בלבד. המשתמש מוותר מראש על כל טענה בנושא.",
          ],
        },
      },
      {
        number: "10",
        title: {
          en: "Complete Waiver and Consent",
          ru: "Полное согласие и отказ от претензий",
          he: "ויתור והסכמה כוללת",
        },
        paragraphs: {
          en: [
            "The user declares that they are aware of the contents of these terms, agree to them fully and without reservation, and waive future claims arising from use of the service.",
          ],
          ru: [
            "Пользователь подтверждает, что ознакомился с содержанием этих условий, полностью и без оговорок согласен с ними и отказывается от будущих претензий, связанных с использованием сервиса.",
          ],
          he: [
            "המשתמש מצהיר כי הוא מודע לתוכן התקנון, מסכים לו באופן מלא וללא הסתייגות, ומוותר על כל טענה עתידית בגין שימוש בשירות.",
          ],
        },
      },
    ],
  },
  warranty: {
    title: {
      en: "Warranty Terms",
      ru: "Условия гарантии",
      he: "תנאי אחריות",
    },
    subtitle: {
      en: "Store terms, delivery conditions and warranty rules.",
      ru: "Условия магазина, поставки и гарантийного обслуживания.",
      he: "תנאי החנות, האספקה והאחריות לשירותים הנרכשים באתר.",
    },
    updatedAt: {
      en: "Current service and warranty policy",
      ru: "Актуальная политика сервиса и гарантии",
      he: "מדיניות אחריות ותנאי שירות",
    },
    intro: {
      en: [
        "These conditions define when a warranty applies, how delivery is performed and what is considered accepted by the customer once payment is completed.",
      ],
      ru: [
        "Эти условия определяют, когда действует гарантия, как выполняется поставка и что считается принятым клиентом после оплаты.",
      ],
      he: [
        "מסמך זה מגדיר מתי חלה אחריות, כיצד מתבצעת האספקה ומה נחשב כמוסכם על הלקוח לאחר ביצוע תשלום.",
      ],
    },
    sections: [
      {
        number: "1",
        title: {
          en: "Conditions for Warranty Coverage",
          ru: "Условия действия гарантии",
          he: "תנאים לקבלת אחריות",
        },
        bullets: {
          en: [
            "Your account must have a profile picture.",
            "The profile must remain public and not private.",
            "Until full delivery of followers and during the full 30-day warranty period:",
            "3.1 Do not switch the profile to private mode.",
            "3.2 Do not change the username or profile URL.",
            "3.3 Do not change profile information such as bio, contact details or links.",
            "3.4 Do not delete your posts.",
            "3.5 Do not order followers from other sources.",
          ],
          ru: [
            "На аккаунте должна быть фотография профиля.",
            "Профиль должен быть открытым, а не приватным.",
            "До полного получения услуги и в течение всего гарантийного периода 30 дней:",
            "3.1 Не закрывайте профиль.",
            "3.2 Не меняйте имя пользователя или URL профиля.",
            "3.3 Не меняйте описание, контактные данные или ссылки в профиле.",
            "3.4 Не удаляйте публикации.",
            "3.5 Не заказывайте подписчиков у других поставщиков.",
          ],
          he: [
            "החשבון שלכם אמור להיות עם תמונת פרופיל.",
            "הפרופיל חייב להיות פתוח (לא פרטי).",
            "עד לקבלת כל העוקבים במלואה ולמשך כל תקופת האחריות (30 יום):",
            "3.1 אין לסגור את הפרופיל (לא להפעיל “חשבון פרטי”).",
            "3.2 אין לשנות את שם המשתמש (ניק-ניים / כתובת URL).",
            "3.3 אין לשנות את המידע בפרופיל (תיאור, פרטי קשר, קישורים).",
            "3.4 אין למחוק את הפוסטים שלכם.",
            "3.5 אין להזמין עוקבים ממקורות אחרים.",
          ],
        },
      },
      {
        number: "2",
        title: {
          en: "Payment and Commercial Terms",
          ru: "Оплата и условия сделки",
          he: "תשלום ותנאי העסקה",
        },
        paragraphs: {
          en: [
            "Payment is made through the Bit app only.",
            "Delivery may begin within up to 14 business days from the moment the order is completed, depending on the purchased service scope.",
            "The process is performed gradually, and the full purchased quantity is intended to be supplied within the stated timeframe.",
            "Refunds are generally not available, except in exceptional cases and solely at the discretion of the service management.",
            "By placing the order and making payment, the customer confirms that they have read, understood and accepted all terms.",
          ],
          ru: [
            "Оплата осуществляется только через приложение Bit.",
            "Поставка может начаться в течение до 14 рабочих дней с момента оформления заказа, в зависимости от объема приобретенной услуги.",
            "Процесс выполняется постепенно, и весь оплаченный объем должен быть предоставлен в указанный срок.",
            "Возврат денежных средств обычно не производится, кроме исключительных случаев и исключительно по усмотрению администрации сервиса.",
            "Оформляя заказ и оплачивая его, клиент подтверждает, что прочитал, понял и принял все условия.",
          ],
          he: [
            "התשלום מתבצע באמצעות אפליקציית ביט בלבד.",
            "האספקה תחל תוך עד 14 ימי עסקים מרגע ביצוע ההזמנה, בהתאם להיקף השירות שנרכש.",
            "התהליך כולו מתבצע באופן הדרגתי, כאשר כל הכמות שנרכשה תסופק במלואה בטווח הזמן שנקבע.",
            "החזר כספי אינו מתאפשר, למעט במקרים חריגים ובשיקול דעת בלעדי של הנהלת השירות.",
            "עם ביצוע ההזמנה והעברת התשלום, הלקוח מאשר כי קרא, הבין והסכים לכלל תנאי התקנון.",
          ],
        },
      },
      {
        number: "3",
        title: {
          en: "Nature of the Service After Delivery",
          ru: "Характер услуги после поставки",
          he: "אופי השירות לאחר אספקה",
        },
        paragraphs: {
          en: [
            "Once the service has been delivered, whether followers, likes or any other service, it cannot be removed or cancelled.",
            "Followers and likes that were added to the account cannot be deleted by the team or by the system, and the previous state cannot be restored.",
            "The system performs orders in a one-way flow only and does not include any removal capability after execution.",
            "The service is provided as-is, and the customer is responsible for understanding that delivered actions cannot be reversed.",
          ],
          ru: [
            "После оказания услуги, будь то подписчики, лайки или любая другая услуга, ее невозможно удалить или отменить.",
            "Добавленные подписчики и лайки не могут быть удалены командой или системой, и вернуть аккаунт в прежнее состояние невозможно.",
            "Система выполняет заказы только в одностороннем порядке и не предусматривает функцию удаления после выполнения.",
            "Услуга предоставляется как есть, и клиент обязан понимать, что выполненные действия не подлежат отмене.",
          ],
          he: [
            "מרגע שהשירות סופק – בין אם מדובר בעוקבים, לייקים או כל שירות אחר – לא ניתן להסירו או לבטלו.",
            "העוקבים והלייקים שנוספו לחשבון אינם ניתנים למחיקה על ידי הצוות או המערכת, ואין באפשרותנו “להחזיר את המצב לקדמותו”.",
            "המערכת שלנו מבצעת את ההזמנות באופן חד-כיווני, ואינה כוללת אפשרות להסרה לאחר ביצוע הפעולה.",
            "השירות ניתן כמות שהוא (As-Is), ובאחריות הלקוח להבין כי אין באפשרותנו להסיר את מה שסופק.",
            "לאחר ביצוע ההזמנה והתחלת תהליך האספקה, הלקוח מאשר כי הוא מודע למדיניות זו ומקבל אותה במלואה.",
          ],
        },
      },
      {
        number: "4",
        title: {
          en: "Quality Commitment",
          ru: "Гарантия качества",
          he: "הבטחת איכות",
        },
        paragraphs: {
          en: [
            "At iFollowers we believe in accurate, transparent and high-quality service. Every order is handled personally while maintaining availability, discretion and consistency.",
            "Delivery is performed within up to 14 business days, depending on the order volume and service procedures.",
            "We commit to supplying the full purchased quantity gradually and responsibly while maintaining a high standard of quality.",
            "Your privacy is important to us. We do not request access to your personal account and do not share information unnecessarily.",
            "If there is an issue or dissatisfaction, you may contact us and we will review an appropriate solution according to service procedures.",
            "With more than six years of experience, hundreds of satisfied customers and personal service, we aim to provide a reliable experience.",
          ],
          ru: [
            "В iFollowers мы делаем ставку на качественный, прозрачный и аккуратный сервис. Каждый заказ обрабатывается индивидуально с учетом доступности, конфиденциальности и контроля качества.",
            "Поставка выполняется в срок до 14 рабочих дней в зависимости от объема заказа и внутренних процедур.",
            "Мы обязуемся предоставить полный оплаченный объем постепенно и ответственно, сохраняя высокий уровень качества.",
            "Ваша конфиденциальность важна для нас. Мы не запрашиваем доступ к вашему личному аккаунту и не делимся информацией без необходимости.",
            "Если возникает проблема или неудовлетворенность, вы можете обратиться к нам, и мы рассмотрим подходящее решение в соответствии с правилами сервиса.",
            "Более шести лет опыта, сотни довольных клиентов и персональный подход лежат в основе сервиса.",
          ],
          he: [
            "אנחנו ב-iFollowers מאמינים בשירות איכותי, מדויק ושקוף. כל הזמנה מטופלת באופן אישי, תוך שמירה על סטנדרטים גבוהים של זמינות, הקפדה ודיסקרטיות.",
            "האספקה מתבצעת בטווח של עד 14 ימי עסקים, בהתאם לנפח ההזמנה ולנהלים הקבועים מראש.",
            "אנו מתחייבים לספק את הכמות המלאה שנרכשה, בצורה הדרגתית ואחראית, תוך שמירה על רמת איכות גבוהה לאורך כל הדרך.",
            "הפרטיות שלך חשובה לנו. איננו משתפים מידע, ואיננו מבקשים גישה לחשבון האישי – השירות מתבצע בצורה חיצונית ובטוחה.",
            "במידה וקיימת בעיה או חוסר שביעות רצון – ניתן לפנות אלינו ונשמח לבדוק פתרון ראוי, בהתאם לנהלי השירות.",
            "עם ניסיון של למעלה מ־6 שנים, מאות לקוחות מרוצים ושירות אישי – אתם בידיים טובות.",
          ],
        },
      },
      {
        number: "5",
        title: {
          en: "Changes to the Policy",
          ru: "Изменения политики",
          he: "שינויים בתקנון",
        },
        paragraphs: {
          en: [
            "The company reserves the right to update, modify or replace these terms at any time, at its sole discretion and without prior notice.",
            "Any change enters into force immediately upon publication on the website, and continued use of the services constitutes renewed consent to the updated terms.",
          ],
          ru: [
            "Компания оставляет за собой право обновлять, изменять или заменять эти условия в любое время по собственному усмотрению и без предварительного уведомления.",
            "Любое изменение вступает в силу сразу после публикации на сайте, а продолжение использования сервиса означает новое согласие с обновленными условиями.",
          ],
          he: [
            "החברה שומרת לעצמה את הזכות לעדכן, לשנות או להחליף את תנאי התקנון בכל עת, לפי שיקול דעתה הבלעדי וללא צורך במתן הודעה מוקדמת.",
            "כל שינוי שיתבצע ייכנס לתוקפו מיד עם פרסומו באתר זה. המשך השימוש בשירותים מהווה הסכמה מחודשת לתקנון המעודכן.",
          ],
        },
      },
    ],
  },
  privacy: {
    title: {
      en: "Privacy Policy",
      ru: "Политика конфиденциальности",
      he: "מדיניות פרטיות",
    },
    subtitle: {
      en: "How iFollowers collects, uses and protects information.",
      ru: "Как iFollowers собирает, использует и защищает информацию.",
      he: "כיצד iFollowers אוסף, משתמש, שומר ומגן על מידע אישי.",
    },
    updatedAt: {
      en: "Last updated: April 19, 2025",
      ru: "Последнее обновление: 19 апреля 2025",
      he: "עודכן לאחרונה: 19 באפריל 2025",
    },
    intro: {
      en: [
        "For convenience, this policy may be written in masculine form, but it applies equally to all genders.",
        "Use of the website constitutes consent to this privacy policy, including the use of cookies for analytics, marketing and user experience improvement.",
      ],
      ru: [
        "Для удобства эта политика может быть сформулирована в мужском роде, однако она одинаково относится ко всем гендерам.",
        "Использование сайта означает согласие с этой политикой конфиденциальности, включая использование cookie для аналитики, маркетинга и улучшения пользовательского опыта.",
      ],
      he: [
        "למען הנוחות בלבד, מדיניות זו נוסחה בלשון זכר – אך מתייחסת באופן שווה לכלל המגדרים והמגדרות.",
        "השימוש באתר מהווה הסכמה מלאה למדיניות זו, לרבות שימוש בעוגיות לצורכי ניתוח, שיווק ושיפור חוויית המשתמש.",
      ],
    },
    sections: [
      {
        number: "1",
        title: {
          en: "Introduction",
          ru: "Введение",
          he: "הקדמה",
        },
        paragraphs: {
          en: [
            "The privacy of our visitors is very important to us, and we are committed to protecting it.",
            "This policy explains how we collect, use, store and protect personal information. If you do not agree to these terms, please avoid using the website.",
          ],
          ru: [
            "Конфиденциальность посетителей сайта очень важна для нас, и мы обязуемся ее защищать.",
            "Эта политика объясняет, как мы собираем, используем, храним и защищаем персональную информацию. Если вы не согласны с этими условиями, пожалуйста, не используйте сайт.",
          ],
          he: [
            "הפרטיות של המבקרים באתר שלנו חשובה לנו מאוד, ואנו מחויבים לשמירה עליה.",
            "מדיניות זו מסבירה כיצד אנו אוספים, משתמשים, שומרים ומגנים על מידע אישי. אם אינך מסכים לתנאים – אנא הימנע משימוש באתר.",
          ],
        },
      },
      {
        number: "2",
        title: {
          en: "Collection of Personal Information",
          ru: "Сбор персональных данных",
          he: "איסוף פרטים אישיים",
        },
        bullets: {
          en: [
            "Technical identifiers: IP address, approximate geographic location, browser type, operating system and device type.",
            "Website activity information: visit duration, viewed pages, referral sources, response times and interactions with forms or buttons.",
            "Registration details: full name, email address, phone number if provided and order details.",
            "Business information: payment details, transaction status, invoices and purchase history.",
            "Additional information the user voluntarily provides through support requests, correspondence or notes.",
          ],
          ru: [
            "Технические идентификаторы: IP-адрес, примерное местоположение, тип браузера, операционная система и тип устройства.",
            "Информация о действиях на сайте: длительность визита, просмотренные страницы, источники переходов, время ответа и взаимодействие с формами или кнопками.",
            "Регистрационные данные: полное имя, адрес электронной почты, номер телефона при предоставлении и сведения о заказах.",
            "Коммерческая информация: платежные данные, статус транзакций, счета и история покупок.",
            "Дополнительная информация, которую пользователь добровольно передает в переписке, обращениях в поддержку или комментариях.",
          ],
          he: [
            "פרטי זיהוי טכניים: כתובת IP, מיקום גאוגרפי מקורב, סוג דפדפן, מערכת הפעלה, סוג מכשיר.",
            "מידע על פעילות באתר: משך ביקור, עמודים שנצפו, מקורות הפנייה, זמן תגובה, אינטראקציות עם טפסים או כפתורים.",
            "פרטי הרשמה: שם מלא, כתובת דוא״ל, מספר טלפון (אם נמסר), פרטי הזמנות.",
            "מידע עסקי: פרטי תשלום, סטטוס עסקאות, חשבוניות, היסטוריית רכישות.",
            "מידע נוסף שהמשתמש מוסר ביוזמתו – בהתכתבויות, פניות שירות או הערות באתר.",
          ],
        },
      },
      {
        number: "3",
        title: {
          en: "Use of Personal Information",
          ru: "Использование персональной информации",
          he: "שימוש בפרטים האישיים",
        },
        bullets: {
          en: [
            "To provide services and complete orders placed on the website.",
            "To improve user experience and personalize content.",
            "To contact users when needed, including customer service, troubleshooting and technical support.",
            "To send marketing messages only after receiving explicit opt-in consent.",
            "To conduct statistical analysis and improve security systems and fraud prevention.",
          ],
          ru: [
            "Для предоставления услуг и выполнения заказов, размещенных на сайте.",
            "Для улучшения пользовательского опыта и персонализации контента.",
            "Для связи с пользователем при необходимости, включая клиентский сервис, решение проблем и техническую поддержку.",
            "Для отправки маркетинговых сообщений только после получения явного согласия.",
            "Для статистического анализа и улучшения систем безопасности и защиты от мошенничества.",
          ],
          he: [
            "לצורך אספקת השירותים והשלמת הזמנות באתר.",
            "לשיפור חוויית המשתמש והתאמה אישית של תכנים.",
            "ליצירת קשר עם המשתמש לפי הצורך, כולל שירות לקוחות, תקלות או תמיכה טכנית.",
            "לשליחת מסרים שיווקיים רק לאחר קבלת הסכמה מפורשת (“אופט-אין”).",
            "לניתוחים סטטיסטיים ולשיפור מערכות האבטחה והגנה מפני הונאות.",
          ],
        },
      },
      {
        number: "4",
        title: {
          en: "Disclosure to Third Parties",
          ru: "Передача данных третьим лицам",
          he: "גילוי מידע לצדדים שלישיים",
        },
        paragraphs: {
          en: [
            "We may share personal information only to the extent required and only with the following parties: law enforcement or regulators as required by law, external service providers such as payment, hosting or analytics systems, and a potential buyer in the case of a business transfer.",
          ],
          ru: [
            "Мы можем передавать персональную информацию только в необходимом объеме и только следующим сторонам: правоохранительным или регулирующим органам по требованию закона, внешним поставщикам сервисов, таким как платежные, хостинговые или аналитические системы, а также потенциальному покупателю при продаже бизнеса.",
          ],
          he: [
            "אנו עשויים לשתף מידע אישי רק עם צדדים שלישיים מהסוגים הבאים, ורק במידה הנדרשת: רשויות החוק או גופים רגולטוריים, ספקי שירות חיצוניים כגון מערכות תשלום, אחסון וניתוח תעבורה, ורוכש פוטנציאלי במסגרת רכישת פעילות העסק או העברת בעלות.",
          ],
        },
      },
      {
        number: "5",
        title: {
          en: "Transfer of Information Outside Israel",
          ru: "Передача данных за пределы Израиля",
          he: "העברת מידע מחוץ לישראל",
        },
        paragraphs: {
          en: [
            "Some services rely on servers and providers located outside Israel. Therefore, personal information may be transferred outside the country, including to jurisdictions that do not provide the same level of protection. Use of the website constitutes consent to this transfer.",
          ],
          ru: [
            "Некоторые сервисы используют серверы и поставщиков за пределами Израиля. Поэтому персональная информация может передаваться за пределы страны, включая юрисдикции с иным уровнем защиты. Использование сайта означает согласие на такую передачу.",
          ],
          he: [
            "חלק מהשירותים מתבססים על שרתים וספקים מחוץ לישראל. בהתאם לכך, מידע אישי עשוי לעבור מחוץ לגבולות המדינה, לרבות למדינות שאינן מציעות הגנה זהה. שימושכם באתר מהווה הסכמה לכך.",
          ],
        },
      },
      {
        number: "6",
        title: {
          en: "Data Retention",
          ru: "Хранение данных",
          he: "שמירת מידע",
        },
        paragraphs: {
          en: [
            "We retain personal information for as long as needed for the purposes described in this policy, unless a different retention period is required by law. When the information is no longer needed, it will be deleted or anonymized.",
          ],
          ru: [
            "Мы храним персональную информацию столько, сколько необходимо для целей, указанных в этой политике, если иной срок не требуется по закону. Когда необходимость отпадает, данные удаляются или обезличиваются.",
          ],
          he: [
            "אנו נשמור את המידע האישי למשך הזמן הנדרש לצורך מטרות השימוש המפורטות במדיניות זו, אלא אם נדרש אחרת על פי חוק. עם סיום הצורך – המידע יימחק או ייעשה אנונימי.",
          ],
        },
      },
      {
        number: "7",
        title: {
          en: "Information Security",
          ru: "Информационная безопасность",
          he: "אבטחת מידע",
        },
        paragraphs: {
          en: [
            "The website uses physical, technical and organizational safeguards, including encrypted communication, access controls and defensive layers designed to reduce intrusion, theft or data corruption.",
            "However, no system can guarantee absolute security.",
          ],
          ru: [
            "Сайт использует физические, технические и организационные меры защиты, включая шифрованную передачу данных, контроль доступа и уровни защиты от вторжений, кражи или повреждения данных.",
            "Однако абсолютную безопасность не может гарантировать ни одна система.",
          ],
          he: [
            "האתר מיישם אמצעים פיזיים, טכניים וארגוניים מתקדמים, לרבות תקשורת מוצפנת, בקרות גישה ושכבות הגנה למניעת חדירות, גניבה או שיבוש נתונים.",
            "עם זאת, אין אפשרות להבטיח אבטחה הרמטית במאה אחוזים.",
          ],
        },
      },
      {
        number: "8",
        title: {
          en: "User Rights",
          ru: "Права пользователя",
          he: "זכויות המשתמשים",
        },
        bullets: {
          en: [
            "The right to review the personal information collected about you.",
            "The right to request correction or deletion of inaccurate or no longer relevant information.",
            "The right to object to processing or request restriction of processing.",
            "The right to receive a copy of your information or transfer it to another entity.",
            "The right to file a complaint with the privacy protection authority.",
          ],
          ru: [
            "Право ознакомиться с персональной информацией, собранной о вас.",
            "Право требовать исправления или удаления неверных либо неактуальных данных.",
            "Право возражать против обработки данных или требовать ее ограничения.",
            "Право получить копию данных или передать их другой организации.",
            "Право подать жалобу в орган по защите конфиденциальности.",
          ],
          he: [
            "הזכות לעיין במידע האישי הנאסף אודותיכם.",
            "הזכות לבקש תיקון או מחיקה של פרטים שגויים או שאינם רלוונטיים עוד.",
            "הזכות להתנגד לעיבוד מידע או לבקש הגבלתו.",
            "הזכות לקבל עותק של המידע או להעבירו לגוף אחר.",
            "הזכות להגיש תלונה לרשות להגנת הפרטיות.",
          ],
        },
      },
      {
        number: "9",
        title: {
          en: "Third-Party Services and External Links",
          ru: "Сторонние сервисы и внешние ссылки",
          he: "צדדים שלישיים וקישורים חיצוניים",
        },
        paragraphs: {
          en: [
            "The website may contain links to third-party websites and services. We do not control their privacy policies and are not responsible for their content, operation or security practices.",
          ],
          ru: [
            "Сайт может содержать ссылки на сторонние сайты и сервисы. Мы не контролируем их политики конфиденциальности и не несем ответственности за их содержание, работу или практики безопасности.",
          ],
          he: [
            "האתר עשוי להכיל קישורים לשירותים ואתרים של צדדים שלישיים. אין לנו שליטה על מדיניות הפרטיות של גורמים אלה, ואיננו נושאים באחריות לתוכנם, לפעולתם או לנוהלי האבטחה שלהם.",
          ],
        },
      },
      {
        number: "10",
        title: {
          en: "Cookies",
          ru: "Файлы cookie",
          he: "עוגיות (Cookies)",
        },
        paragraphs: {
          en: [
            "The website uses cookies for user recognition, traffic analysis and content personalization. Cookie settings can be controlled in the browser, and cookies may be deleted at any time.",
          ],
          ru: [
            "Сайт использует cookie для распознавания пользователей, анализа трафика и персонализации контента. Управлять cookie можно через настройки браузера, а удалить их можно в любой момент.",
          ],
          he: [
            "האתר משתמש בקבצי עוגיות לזיהוי משתמשים, ניתוח תעבורה והתאמה אישית של תכנים. ניתן לשלוט בהגדרות העוגיות דרך הדפדפן ואף למחוק אותן בכל עת.",
          ],
        },
      },
      {
        number: "11",
        title: {
          en: "Policy Updates",
          ru: "Обновления политики",
          he: "עדכונים למדיניות",
        },
        paragraphs: {
          en: [
            "We reserve the right to update this policy based on regulatory or operational changes. The last update date appears at the top of this document, and we recommend reviewing it from time to time.",
          ],
          ru: [
            "Мы оставляем за собой право обновлять эту политику в связи с регуляторными или операционными изменениями. Дата последнего обновления указана в начале документа, и мы рекомендуем периодически просматривать ее.",
          ],
          he: [
            "אנו שומרים לעצמנו את הזכות לעדכן מדיניות זו בהתאם לשינויים רגולטוריים או תפעוליים. תאריך העדכון האחרון יופיע בראש המסמך. אנו ממליצים לבדוק את המדיניות מעת לעת.",
          ],
        },
      },
      {
        number: "12",
        title: {
          en: "Contact",
          ru: "Контакты",
          he: "יצירת קשר",
        },
        paragraphs: {
          en: [
            "For questions, clarifications or requests regarding privacy and your rights, you may contact us by email at ifollowers.israel@gmail.com or via https://ifollowers.site.",
          ],
          ru: [
            "По вопросам, разъяснениям или запросам, связанным с конфиденциальностью и вашими правами, можно связаться с нами по адресу ifollowers.israel@gmail.com или через https://ifollowers.site.",
          ],
          he: [
            "לשאלות, הבהרות או בקשות בנוגע לפרטיות ולזכויותיכם, ניתן לפנות אלינו בדוא״ל ifollowers.israel@gmail.com או דרך https://ifollowers.site.",
          ],
        },
      },
    ],
  },
};

export const faqPage = {
  title: {
    en: "Frequently Asked Questions",
    ru: "Частые вопросы",
    he: "שאלות ותשובות נפוצות",
  },
  subtitle: {
    en: "Clear answers to the questions customers ask most before ordering.",
    ru: "Понятные ответы на вопросы, которые клиенты чаще всего задают перед заказом.",
    he: "מענה ברור לשאלות שלקוחות שואלים הכי הרבה לפני הזמנה.",
  },
  updatedAt: {
    en: "iFollowers customer FAQ",
    ru: "База ответов iFollowers",
    he: "מרכז תשובות ללקוחות iFollowers",
  },
  items: [
    {
      question: {
        en: "Why buy followers from us at all?",
        ru: "Почему вообще покупать подписчиков у нас?",
        he: "למה שתקבלו מאיתנו עוקבים בכלל?",
      },
      answer: {
        en: [
          "Because visibility matters. On social media, visibility builds trust, and a stronger profile often creates a better first impression.",
          "Our role is to give a smart boost to creators, brands and businesses that are already investing in content and want to look more established.",
        ],
        ru: [
          "Потому что видимость имеет значение. В социальных сетях именно она формирует доверие и первое впечатление.",
          "Наша задача — дать дополнительный импульс тем, кто уже вкладывается в контент и хочет выглядеть сильнее и убедительнее.",
        ],
        he: [
          "כי מגיע לכם להיראות. בעידן של רשתות חברתיות, נראות = אמון.",
          "אנחנו כאן כדי לתת דחיפה למי שמשקיע בתוכן, מנסה לבלוט ורוצה להיראות רציני יותר.",
        ],
      },
    },
    {
      question: {
        en: "Are these bots?",
        ru: "Это боты?",
        he: "זה בוטים?",
      },
      answer: {
        en: [
          "Part of the service may rely on automated processes. Automation by itself is not unusual and is widely used by brands and marketing tools.",
          "The service is meant to support profile appearance and visibility, not to ask for your password or direct access to your account.",
        ],
        ru: [
          "Часть сервиса может работать на автоматизированных процессах. Сама по себе автоматизация давно используется брендами и маркетинговыми инструментами.",
          "Сервис предназначен для усиления внешнего вида и видимости профиля, а не для получения пароля или прямого доступа к аккаунту.",
        ],
        he: [
          "חלק מהשירות מבוסס על אוטומציה חכמה. זו לא מילה גסה – גם מותגים גדולים משתמשים בכלים אוטומטיים לחיזוק נראות.",
          "אנחנו לא מבקשים גישה לחשבון שלכם ולא סיסמה – רק מספקים שירות חיצוני לחיזוק הנראות.",
        ],
      },
    },
    {
      question: {
        en: "Will the followers really watch my stories?",
        ru: "Эти подписчики действительно будут смотреть сторис?",
        he: "העוקבים באמת יצפו בסטורי?",
      },
      answer: {
        en: [
          "Some followers may be real users, so additional views can happen, but that is not the core promise of the service.",
          "The main goal is profile appearance, social proof and stronger branding rather than guaranteed engagement.",
        ],
        ru: [
          "Часть подписчиков может быть реальными пользователями, поэтому дополнительные просмотры возможны, но это не основное обещание сервиса.",
          "Главная цель — визуальная сила профиля, социальное доказательство и более убедительный бренд, а не гарантированная вовлеченность.",
        ],
        he: [
          "חלק מהעוקבים הם משתמשים אמיתיים ולכן ייתכן שתראו גם צפיות נוספות.",
          "עם זאת, המטרה העיקרית של השירות היא חיזוק מיתוג ונראות – לא בהכרח מעורבות.",
        ],
      },
    },
    {
      question: {
        en: "How many followers can I buy?",
        ru: "Сколько подписчиков можно заказать?",
        he: "כמה עוקבים אפשר לרכוש?",
      },
      answer: {
        en: [
          "The website offers packages starting from small quantities and scaling up to large volumes, depending on the service currently listed in the shop.",
          "Large custom orders can be handled separately when relevant.",
        ],
        ru: [
          "На сайте доступны пакеты от небольших количеств до крупных объемов — в зависимости от того, какие товары сейчас опубликованы в магазине.",
          "Крупные и нестандартные заказы можно рассматривать отдельно при необходимости.",
        ],
        he: [
          "אנחנו מציעים חבילות החל מכמויות קטנות ועד כמויות גדולות, בהתאם למה שמופיע כרגע בחנות.",
          "בהזמנות גדולות או מיוחדות אפשר גם לבדוק התאמה אישית.",
        ],
      },
    },
    {
      question: {
        en: "Who receives the payment?",
        ru: "Кому уходит оплата?",
        he: "למי מועבר התשלום?",
      },
      answer: {
        en: [
          "Payment is made directly to iFollowers according to the payment flow displayed on the website.",
          "You are working with a private business service and not transferring money to a random user.",
        ],
        ru: [
          "Оплата проходит напрямую в iFollowers по платежному сценарию, который показан на сайте.",
          "Речь идет о частном бизнес-сервисе, а не о переводе случайному пользователю.",
        ],
        he: [
          "התשלום מועבר אלינו ישירות – לצוות iFollowers.",
          "מדובר בעסק פרטי ומסודר עם שירות לקוחות זמין.",
        ],
      },
    },
    {
      question: {
        en: "What do you gain from it?",
        ru: "Что вы с этого получаете?",
        he: "מה יוצא לנו מזה?",
      },
      answer: {
        en: [
          "Like any service business, we earn from completed orders.",
          "Long term, customer satisfaction and repeat customers matter more than a single transaction.",
        ],
        ru: [
          "Как и любой сервисный бизнес, мы зарабатываем на выполненных заказах.",
          "В долгую нам важнее довольный клиент и повторные заказы, чем разовая сделка.",
        ],
        he: [
          "אנחנו מרוויחים מכל עסקה, אבל הרבה יותר חשוב לנו שתחזרו, שתהיו מרוצים ושתמליצו.",
        ],
      },
    },
    {
      question: {
        en: "How do you do it?",
        ru: "Как это вообще работает?",
        he: "איך אנחנו עושים את זה?",
      },
      answer: {
        en: [
          "The service is powered by digital workflows, provider integrations and external delivery systems.",
          "No password or direct account access is required for normal use of the service.",
        ],
        ru: [
          "Сервис работает через цифровые процессы, интеграции с поставщиками и внешние системы доставки.",
          "Для обычного использования сервиса пароль или прямой доступ к аккаунту не требуются.",
        ],
        he: [
          "באמצעות טכנולוגיות מתקדמות, ממשקי API ושותפויות עם ספקים גלובליים.",
          "בלי גישה לחשבון שלכם ובלי סיסמאות – רק כלים מקצועיים וחיצוניים.",
        ],
      },
    },
    {
      question: {
        en: "How can I convince my parents to let me order?",
        ru: "Как убедить родителей разрешить заказать?",
        he: "איך לשכנע את ההורים להזמין?",
      },
      answer: {
        en: [
          "Show them that the service is organized, has clear terms and offers real customer support.",
          "If needed, they can review the legal and warranty pages directly on the website before any payment is made.",
        ],
        ru: [
          "Покажите, что сервис оформлен прозрачно, с понятными условиями и реальной поддержкой.",
          "При необходимости родители могут сами прочитать правовые и гарантийные условия на сайте до оплаты.",
        ],
        he: [
          "הראו להם שאנחנו עסק מסודר עם תקנון, תנאי אחריות ושירות לקוחות אמיתי.",
          "במידת הצורך הם יכולים לעבור על הדפים הרשמיים באתר לפני כל תשלום.",
        ],
      },
    },
    {
      question: {
        en: "How do I know you are not scamming me?",
        ru: "Как понять, что это не обман?",
        he: "איך תדעו שאנחנו לא עובדים עליכם?",
      },
      answer: {
        en: [
          "You can judge that by the transparency of the process, the visible order flow and the warranty terms published on the website.",
          "If there is a real service issue, support can review it and handle it according to policy.",
        ],
        ru: [
          "Об этом лучше всего судить по прозрачности процесса, понятному пути заказа и опубликованным на сайте гарантийным условиям.",
          "Если возникает реальная проблема с услугой, поддержка рассматривает ее по правилам сервиса.",
        ],
        he: [
          "הדרך לבדוק היא לפי השקיפות, תהליך ההזמנה הברור ותנאי האחריות שמופיעים באתר.",
          "אם קיימת בעיית שירות אמיתית – התמיכה בודקת אותה ופועלת לפי המדיניות.",
        ],
      },
    },
    {
      question: {
        en: "When will the followers start arriving?",
        ru: "Когда начнут приходить подписчики?",
        he: "מתי יתחילו להגיע העוקבים?",
      },
      answer: {
        en: [
          "In many cases delivery starts relatively quickly, but the official service window is up to 14 business days according to the policy.",
          "Delivery is usually gradual and controlled rather than instant.",
        ],
        ru: [
          "Во многих случаях поставка начинается достаточно быстро, но официальный срок по правилам сервиса — до 14 рабочих дней.",
          "Как правило, выполнение идет постепенно и контролируемо, а не мгновенно.",
        ],
        he: [
          "במקרים רבים ההתחלה יחסית מהירה, אך לפי המדיניות ההשלמה יכולה לקחת עד 14 ימי עסקים.",
          "האספקה מתבצעת באופן הדרגתי ומבוקר.",
        ],
      },
    },
    {
      question: {
        en: "What if it does not work? Do I get a refund?",
        ru: "Что если это не сработает? Будет возврат?",
        he: "ומה אם זה לא יעבוד? תקבלו החזר?",
      },
      answer: {
        en: [
          "Refunds are not the standard outcome. Exceptional cases are handled according to the service policy and management discretion.",
          "Where relevant, a refill or another practical solution may be offered instead.",
        ],
        ru: [
          "Возврат денег не является стандартным сценарием. Исключительные случаи рассматриваются по политике сервиса и на усмотрение администрации.",
          "Когда это уместно, вместо возврата может быть предложен refill или другое практичное решение.",
        ],
        he: [
          "ככלל, אין החזר כספי אלא אם מדובר במקרה חריג ובהתאם למדיניות השירות.",
          "כאשר זה מתאים, אפשר להציע מילוי חוזר או פתרון אחר במקום החזר.",
        ],
      },
    },
    {
      question: {
        en: "What if followers drop after a few days?",
        ru: "Что делать, если через несколько дней часть подписчиков ушла?",
        he: "מה עושים אם ירדו לי עוקבים אחרי כמה ימים?",
      },
      answer: {
        en: [
          "Follower drops can happen naturally. If you kept all warranty conditions, a refill may be checked according to the warranty policy.",
        ],
        ru: [
          "Снижение числа подписчиков может происходить естественным образом. Если вы соблюдали все гарантийные условия, можно проверить возможность refill по гарантийной политике.",
        ],
        he: [
          "ירידת עוקבים היא תופעה שיכולה לקרות. אם שמרתם על כל תנאי האחריות, אפשר לבדוק מילוי מחדש לפי מדיניות האחריות.",
        ],
      },
      link: {
        path: "/warranty",
        label: {
          en: "Read full warranty terms",
          ru: "Читать полные условия гарантии",
          he: "לקריאת תנאי האחריות המלאים",
        },
      },
    },
    {
      question: {
        en: "Do you provide a warranty?",
        ru: "Есть ли гарантия на сервис?",
        he: "יש אחריות על השירות שלכם?",
      },
      answer: {
        en: [
          "Yes. Warranty handling depends on compliance with the published conditions, including account visibility and profile stability during the covered period.",
        ],
        ru: [
          "Да. Работа по гарантии зависит от соблюдения опубликованных условий, включая открытый профиль и стабильность аккаунта в течение гарантийного периода.",
        ],
        he: [
          "כן. האחריות תלויה בעמידה בתנאים שפורסמו, כולל פרופיל פתוח ויציב לאורך תקופת האחריות.",
        ],
      },
      link: {
        path: "/warranty",
        label: {
          en: "Official warranty policy",
          ru: "Официальная гарантийная политика",
          he: "תקנון האחריות הרשמי",
        },
      },
    },
    {
      question: {
        en: "Do you sell the blue verification badge?",
        ru: "Вы продаете синюю галочку?",
        he: "האם אתם מוכרים ווי כחול?",
      },
      answer: {
        en: [
          "No. Verification badges are granted by the platform itself.",
          "The service may help a profile look stronger and more established, but it does not grant official verification.",
        ],
        ru: [
          "Нет. Официальную верификацию выдает сама платформа.",
          "Сервис может помочь профилю выглядеть сильнее и убедительнее, но не выдает официальную галочку.",
        ],
        he: [
          "לא. רק META או הפלטפורמה עצמה מעניקה סימון אימות רשמי.",
          "אנחנו יכולים לעזור לפרופיל להיראות אמין וחזק יותר, אבל לא למכור אימות רשמי.",
        ],
      },
    },
    {
      question: {
        en: "Can purchased followers or likes be removed afterward?",
        ru: "Можно ли потом удалить купленные подписчики или лайки?",
        he: "האם אפשר להוריד עוקבים או לייקים שרכשתי?",
      },
      answer: {
        en: [
          "No. After the order is delivered, the system does not include a reverse removal flow.",
          "It is recommended not to make sharp profile changes while delivery is still in progress.",
        ],
        ru: [
          "Нет. После выполнения заказа система не предусматривает обратное удаление.",
          "Пока поставка еще идет, лучше не делать резких изменений в профиле.",
        ],
        he: [
          "לא. לאחר שהשירות סופק, אין מנגנון להסרה יזומה של מה שכבר נוסף.",
          "מומלץ לא לבצע שינויים חדים בפרופיל בזמן שהאספקה עדיין בתהליך.",
        ],
      },
    },
  ],
  contactCard: {
    title: {
      en: "Customer Service",
      ru: "Служба поддержки",
      he: "שירות לקוחות",
    },
    body: {
      en: "If you still need help, open customer service and continue with our support team directly from the website.",
      ru: "Если у вас остались вопросы, откройте поддержку и продолжите общение с нашей службой поддержки прямо на сайте.",
      he: "אם עדיין יש לכם שאלה, אפשר לפתוח שירות לקוחות ולהמשיך מול התמיכה שלנו ישירות דרך האתר.",
    },
    email: "ifollowers.israel@gmail.com",
    website: "https://ifollowers.site",
  },
};
